import React, { FunctionComponent } from 'react';
import Text, {
    TextSize,
    TextBasicProps,
    TextCommonProps,
    TextExtendedProps,
} from 'components/typography/text';

type P1Props = TextBasicProps & TextCommonProps & TextExtendedProps;

const P1: FunctionComponent<P1Props> = (props) => {
    const {
        children,
        align,
        color,
        weight,
        isInline,
        hasEllipsis,
        hasBreakWords,
        isDangerous,
        tag,
    } = props;

    return (
        <Text
            size={TextSize.P1}
            align={align}
            color={color}
            weight={weight}
            isInline={isInline}
            hasEllipsis={hasEllipsis}
            hasBreakWords={hasBreakWords}
            isDangerous={isDangerous}
            tag={tag}
        >
            {children}
        </Text>
    );
};

export default P1;
